<script>
  export let resultInfo = '';
  export let resultText;

  import { InputStore } from "../store";
  let Input = {}

  InputStore.subscribe((current) => {Input = current})

  function copy() {
    navigator.clipboard.writeText(resultText);
  }

  function toInput() {
    InputStore.update((current) => current = {...Input, text: resultText})
  }
</script>

<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0" />

<div class="result">
  <div class="resultText">
    {#if resultInfo !== ''}
      {resultInfo}: 
    {/if}
    {resultText}
  </div>

  <div class="actionButtons">
    <button on:click={copy}>
      <span class="material-symbols-outlined">
        content_copy
      </span>
    </button>
    <button on:click={toInput}>
      <span class="material-symbols-outlined">
        move_group
      </span>
    </button>
  </div>
</div>

<style>
  .result {
    display: flex;
    justify-content: space-between;
  }

  button {
    background: rgba(0,0,0,0);

    border-radius: 5px;

    cursor: pointer;
    padding: 3px;
  }

  button:hover {
    background: rgba(0,0,0,0.1);
  }

</style>